//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import ServiceLinkClientBase from "./serviceLinkClient.base";

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IServiceLinkClient {
  /**
   * Gets a proposal by its Id
   * @return OK
   */
  customerViewGET(id: string): Promise<CustomerViewResponse>;

  /**
   * Mark the proposal as opened by customer.
   * @param body (optional)
   * @return OK
   */
  customerViewOpenedByCustomerPOST(body: string | undefined): Promise<void>;

  /**
   * The customer should report back what items the customer accepted.
   * @param body (optional)
   * @return OK
   */
  customerViewRespondPOST(
    body: CustomerResponseRequest | undefined
  ): Promise<void>;

  /**
   * Creates a damage inspection
   * @param body (optional)
   * @return Created
   */
  damageInspectionPOST(
    body: CreateDamageInspectionRequest | undefined
  ): Promise<DamageInspectionResponse>;

  /**
   * Update a damage inspection
   * @param body (optional)
   * @return OK
   */
  damageInspectionPUT(
    id: string,
    body: UpdateDamageInspectionRequest | undefined
  ): Promise<DamageInspectionResponse>;

  /**
   * Get damage inspection by id
   * @return OK
   */
  damageInspectionGET(id: string): Promise<DamageInspectionResponse>;

  /**
   * Lists all damage inspections
   * @param dealershipId (optional)
   * @param count (optional)
   * @return OK
   */
  damageInspectionListPOST(
    dealershipId: string | undefined,
    count: number | undefined
  ): Promise<DamageInspectionListItemResponse[]>;

  /**
   * Get damage inspection items
   * @return OK
   */
  damageInspectionItemGET(id: string): Promise<DamageInspectionItemResponse[]>;

  /**
   * Create a damage inspection item
   * @param body (optional)
   * @return Created
   */
  damageInspectionItemPOST(
    id: string,
    body: CreateDamageInspectionItemRequest | undefined
  ): Promise<DamageInspectionItemResponse>;

  /**
   * Update a damage inspection item
   * @param body (optional)
   * @return OK
   */
  damageInspectionItemPUT(
    body: UpdateDamageInspectionItemRequest | undefined
  ): Promise<DamageInspectionItemResponse>;

  /**
   * Delete a damage inspection item
   * @return No Content
   */
  damageInspectionItemDELETE(id: number): Promise<void>;

  /**
   * Create a damage inspection item media relation
   * @param body (optional)
   * @return Created
   */
  damageInspectionItemMediaPOST(
    body: CreateDamageInspectionItemMediaRequest | undefined
  ): Promise<DamageInspectionItemMediaResponse>;

  /**
   * Update a damage inspection item media
   * @param body (optional)
   * @return OK
   */
  damageInspectionItemMediaPUT(
    body: UpdateDamageInspectionItemMediaRequest | undefined
  ): Promise<DamageInspectionItemMediaResponse>;

  /**
   * Delete a damage inspection item media relation
   * @return No Content
   */
  damageInspectionItemMediaDELETE(id: number): Promise<void>;

  /**
   * Get case history
   * @param dealerNumber (optional)
   * @param registrationNumber (optional)
   * @return OK
   */
  damageInspectionHistoryGET(
    dealerNumber: string | undefined,
    registrationNumber: string | undefined
  ): Promise<CaseHistoryListItemResponse[]>;

  /**
   * Search for a damage inspection
   * @param dealershipId (optional)
   * @param searchTerm (optional)
   * @param count (optional)
   * @return OK
   */
  damageInspectionSearchGET(
    dealershipId: string | undefined,
    searchTerm: string | undefined,
    count: number | undefined
  ): Promise<DamageInspectionListItemResponse[]>;

  /**
   * Get material inspection list
   * @param dealershipId (optional)
   * @param count (optional)
   * @return OK
   */
  materialInspectionListGET(
    dealershipId: string | undefined,
    count: number | undefined
  ): Promise<MaterialInspectionListItemResponse[]>;

  /**
   * Get a material inspection
   * @return OK
   */
  materialInspectionGET(id: string): Promise<MaterialInspectionResponse>;

  /**
   * Update a material inspection
   * @param body (optional)
   * @return OK
   */
  materialInspectionPUT(
    id: string,
    body: UpdateMaterialInspectionRequest | undefined
  ): Promise<MaterialInspectionResponse>;

  /**
   * Create a material inspection
   * @param body (optional)
   * @return OK
   */
  materialInspectionPOST(
    body: CreateMaterialInspectionRequest | undefined
  ): Promise<MaterialInspectionResponse>;

  /**
   * Get material inspection items
   * @return OK
   */
  materialInspectionItemGET(
    id: string
  ): Promise<MaterialInspectionItemResponse[]>;

  /**
   * Update a material inspection item
   * @param body (optional)
   * @return OK
   */
  materialInspectionItemPUT(
    body: UpdateMaterialInspectionItemRequest | undefined
  ): Promise<MaterialInspectionItemResponse>;

  /**
   * Create a material inspection item media relation
   * @param body (optional)
   * @return Created
   */
  materialInspectionItemMediaPOST(
    body: CreateMaterialInspectionItemMediaRequest | undefined
  ): Promise<MaterialInspectionItemMediaResponse>;

  /**
   * Update a material inspection item media
   * @param body (optional)
   * @return OK
   */
  materialInspectionItemMediaPUT(
    body: UpdateMaterialInspectionItemMediaRequest | undefined
  ): Promise<MaterialInspectionItemMediaResponse>;

  /**
   * Delete a material inspection item media relation
   * @return No Content
   */
  materialInspectionItemMediaDELETE(id: number): Promise<void>;

  /**
   * Get material inspection items
   * @param dealerNumber (optional)
   * @param registrationNumber (optional)
   * @return OK
   */
  materialInspectionHistoryGET(
    dealerNumber: string | undefined,
    registrationNumber: string | undefined
  ): Promise<CaseHistoryListItemResponse[]>;

  /**
   * Search for a material inspection
   * @param dealershipId (optional)
   * @param searchTerm (optional)
   * @param count (optional)
   * @return OK
   */
  materialInspectionSearchGET(
    dealershipId: string | undefined,
    searchTerm: string | undefined,
    count: number | undefined
  ): Promise<MaterialInspectionListItemResponse[]>;

  /**
   * Upload a file from a form
   * @param files (optional)
   * @param vIN (optional)
   * @param dealerNumber (optional)
   * @param type (optional)
   * @return OK
   */
  mediaPOST(
    files: FileParameter[] | undefined,
    vIN: string | undefined,
    dealerNumber: string | undefined,
    type: MediaTypeEnum | undefined
  ): Promise<string[]>;

  /**
   * Gets a file from storage
   * @param type (optional)
   * @return OK
   */
  mediaGET(id: string, type: MediaTypeEnum | undefined): Promise<FileResponse>;

  /**
   * Update status of a proposalMediaItem
   * @param body (optional)
   * @return OK
   */
  mediaAddHistoryPOST(body: AddMediaHistoryRequest | undefined): Promise<void>;

  /**
   * Gets a proposal by its Id
   * @return OK
   */
  proposalGET(id: string): Promise<ProposalResponse>;

  /**
   * Soft delete a proposal
   * @return No Content
   */
  proposalDELETE(id: string): Promise<void>;

  /**
   * Gets a filtered list of proposals
   * @param dateFrom (optional)
   * @param dateTo (optional)
   * @param brand (optional)
   * @param searchTerm (optional)
   * @param skip (optional)
   * @param limit (optional)
   * @param statuses (optional)
   * @return OK
   */
  proposalSearchGET(
    dealerNumber: string,
    dateFrom: Date | undefined,
    dateTo: Date | undefined,
    brand: BrandCodeEnum | undefined,
    searchTerm: string | undefined,
    skip: number | undefined,
    limit: number | undefined,
    statuses: ProposalStatusEnum[] | undefined
  ): Promise<SearchProposalResponse>;

  /**
   * Gets a full length list of proposals
   * @param body (optional)
   * @return OK
   */
  proposalListPOST(
    body: ListProposalsRequest | undefined
  ): Promise<ProposalResponse[]>;

  /**
   * Creates an empty proposal with the minimum required props
   * @param body (optional)
   * @return OK
   */
  proposalCreatePOST(body: CreateProposalRequest | undefined): Promise<string>;

  /**
   * Updates the proposal with the provided information
   * @param body (optional)
   * @return OK
   */
  proposalUpdatePOST(body: UpdateProposalRequest | undefined): Promise<void>;

  /**
   * Sends the vbo proposal and updates its status to sent.
   * @param body (optional)
   * @return OK
   */
  proposalSendPOST(body: SendProposalRequest | undefined): Promise<void>;

  /**
   * Get all available priorities for proposals.
   * @param accept_Language (optional)
   * @return OK
   */
  proposalPrioritiesAllGET(
    accept_Language: string | undefined
  ): Promise<PriorityResponse[]>;

  /**
   * Get a list of status history
   * @return OK
   */
  proposalStatusHistoryGET(
    id: string
  ): Promise<ProposalStatusHistoryResponse[]>;

  /**
   * Updates the proposal item with the provided information
   * @param body (optional)
   * @return OK
   */
  proposalItemUpdatePOST(
    proposalId: string,
    body: UpdateProposalItemRequest | undefined
  ): Promise<ProposalItemResponse>;

  /**
   * Get a list of proposal items
   * @return OK
   */
  proposalItemsGET(id: string): Promise<ProposalItemResponse[]>;

  /**
   * Get a proposal item
   * @return OK
   */
  proposalItemGET(id: string, itemId: number): Promise<ProposalItemResponse>;

  /**
   * Create a new proposal item
   * @param body (optional)
   * @return OK
   */
  proposalItemPOST(
    proposalId: string,
    body: CreateProposalItemRequest | undefined
  ): Promise<ProposalItemResponse>;

  /**
   * Create a new proposal item
   * @param body (optional)
   * @return No Content
   */
  proposalItemDeletePOST(
    proposalId: string,
    body: DeleteProposalItemRequest | undefined
  ): Promise<void>;

  /**
   * Get a proposal
   * @return OK
   */
  proposalV2GET(id: string): Promise<ProposalResponseV2>;

  /**
   * Updates the proposal with the provided information
   * @param body (optional)
   * @return OK
   */
  proposalUpdatePOST2(
    body: UpdateProposalRequestV2 | undefined
  ): Promise<ProposalResponseV2>;

  /**
   * Upload a file from a form
   * @param type (optional)
   * @param files (optional)
   * @return OK
   * @deprecated
   */
  create(
    type: MediaTypeEnum | undefined,
    files: FileParameter[] | undefined
  ): Promise<string[]>;

  /**
   * Delete a file from storage
   * @param type (optional)
   * @return OK
   */
  uploadDELETE(id: string, type: MediaTypeEnum | undefined): Promise<string>;

  /**
   * Gets a file from storage
   * @param type (optional)
   * @return OK
   * @deprecated
   */
  uploadGET(id: string, type: MediaTypeEnum | undefined): Promise<FileResponse>;
}

export class ServiceLinkClient
  extends ServiceLinkClientBase
  implements IServiceLinkClient
{
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  /**
   * Gets a proposal by its Id
   * @return OK
   */
  customerViewGET(id: string): Promise<CustomerViewResponse> {
    let url_ = this.baseUrl + "/api/v1/customerview/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCustomerViewGET(_response);
    });
  }

  protected processCustomerViewGET(
    response: Response
  ): Promise<CustomerViewResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CustomerViewResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Not Found", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CustomerViewResponse>(null as any);
  }

  /**
   * Mark the proposal as opened by customer.
   * @param body (optional)
   * @return OK
   */
  customerViewOpenedByCustomerPOST(body: string | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/customerview/opened-by-customer";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCustomerViewOpenedByCustomerPOST(_response);
    });
  }

  protected processCustomerViewOpenedByCustomerPOST(
    response: Response
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * The customer should report back what items the customer accepted.
   * @param body (optional)
   * @return OK
   */
  customerViewRespondPOST(
    body: CustomerResponseRequest | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/customerview/respond";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCustomerViewRespondPOST(_response);
    });
  }

  protected processCustomerViewRespondPOST(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Creates a damage inspection
   * @param body (optional)
   * @return Created
   */
  damageInspectionPOST(
    body: CreateDamageInspectionRequest | undefined
  ): Promise<DamageInspectionResponse> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionPOST(_response);
    });
  }

  protected processDamageInspectionPOST(
    response: Response
  ): Promise<DamageInspectionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = DamageInspectionResponse.fromJS(resultData201);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DamageInspectionResponse>(null as any);
  }

  /**
   * Update a damage inspection
   * @param body (optional)
   * @return OK
   */
  damageInspectionPUT(
    id: string,
    body: UpdateDamageInspectionRequest | undefined
  ): Promise<DamageInspectionResponse> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionPUT(_response);
    });
  }

  protected processDamageInspectionPUT(
    response: Response
  ): Promise<DamageInspectionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DamageInspectionResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DamageInspectionResponse.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DamageInspectionResponse>(null as any);
  }

  /**
   * Get damage inspection by id
   * @return OK
   */
  damageInspectionGET(id: string): Promise<DamageInspectionResponse> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionGET(_response);
    });
  }

  protected processDamageInspectionGET(
    response: Response
  ): Promise<DamageInspectionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DamageInspectionResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException("No Content", status, _responseText, _headers);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DamageInspectionResponse>(null as any);
  }

  /**
   * Lists all damage inspections
   * @param dealershipId (optional)
   * @param count (optional)
   * @return OK
   */
  damageInspectionListPOST(
    dealershipId: string | undefined,
    count: number | undefined
  ): Promise<DamageInspectionListItemResponse[]> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/list?";
    if (dealershipId === null)
      throw new Error("The parameter 'dealershipId' cannot be null.");
    else if (dealershipId !== undefined)
      url_ += "dealershipId=" + encodeURIComponent("" + dealershipId) + "&";
    if (count === null)
      throw new Error("The parameter 'count' cannot be null.");
    else if (count !== undefined)
      url_ += "count=" + encodeURIComponent("" + count) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionListPOST(_response);
    });
  }

  protected processDamageInspectionListPOST(
    response: Response
  ): Promise<DamageInspectionListItemResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DamageInspectionListItemResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DamageInspectionListItemResponse[]>(null as any);
  }

  /**
   * Get damage inspection items
   * @return OK
   */
  damageInspectionItemGET(id: string): Promise<DamageInspectionItemResponse[]> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/{id}/item";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionItemGET(_response);
    });
  }

  protected processDamageInspectionItemGET(
    response: Response
  ): Promise<DamageInspectionItemResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DamageInspectionItemResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DamageInspectionItemResponse[]>(null as any);
  }

  /**
   * Create a damage inspection item
   * @param body (optional)
   * @return Created
   */
  damageInspectionItemPOST(
    id: string,
    body: CreateDamageInspectionItemRequest | undefined
  ): Promise<DamageInspectionItemResponse> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/{id}/item";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionItemPOST(_response);
    });
  }

  protected processDamageInspectionItemPOST(
    response: Response
  ): Promise<DamageInspectionItemResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = DamageInspectionItemResponse.fromJS(resultData201);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = resultData400 !== undefined ? resultData400 : <any>null;

        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DamageInspectionItemResponse>(null as any);
  }

  /**
   * Update a damage inspection item
   * @param body (optional)
   * @return OK
   */
  damageInspectionItemPUT(
    body: UpdateDamageInspectionItemRequest | undefined
  ): Promise<DamageInspectionItemResponse> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/item";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionItemPUT(_response);
    });
  }

  protected processDamageInspectionItemPUT(
    response: Response
  ): Promise<DamageInspectionItemResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DamageInspectionItemResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DamageInspectionItemResponse.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DamageInspectionItemResponse>(null as any);
  }

  /**
   * Delete a damage inspection item
   * @return No Content
   */
  damageInspectionItemDELETE(id: number): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/item/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionItemDELETE(_response);
    });
  }

  protected processDamageInspectionItemDELETE(
    response: Response
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = resultData400 !== undefined ? resultData400 : <any>null;

        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Create a damage inspection item media relation
   * @param body (optional)
   * @return Created
   */
  damageInspectionItemMediaPOST(
    body: CreateDamageInspectionItemMediaRequest | undefined
  ): Promise<DamageInspectionItemMediaResponse> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/item/media";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionItemMediaPOST(_response);
    });
  }

  protected processDamageInspectionItemMediaPOST(
    response: Response
  ): Promise<DamageInspectionItemMediaResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = DamageInspectionItemMediaResponse.fromJS(resultData201);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DamageInspectionItemMediaResponse.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DamageInspectionItemMediaResponse>(null as any);
  }

  /**
   * Update a damage inspection item media
   * @param body (optional)
   * @return OK
   */
  damageInspectionItemMediaPUT(
    body: UpdateDamageInspectionItemMediaRequest | undefined
  ): Promise<DamageInspectionItemMediaResponse> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/item/media";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionItemMediaPUT(_response);
    });
  }

  protected processDamageInspectionItemMediaPUT(
    response: Response
  ): Promise<DamageInspectionItemMediaResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DamageInspectionItemMediaResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DamageInspectionItemMediaResponse.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DamageInspectionItemMediaResponse>(null as any);
  }

  /**
   * Delete a damage inspection item media relation
   * @return No Content
   */
  damageInspectionItemMediaDELETE(id: number): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/item/media/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionItemMediaDELETE(_response);
    });
  }

  protected processDamageInspectionItemMediaDELETE(
    response: Response
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get case history
   * @param dealerNumber (optional)
   * @param registrationNumber (optional)
   * @return OK
   */
  damageInspectionHistoryGET(
    dealerNumber: string | undefined,
    registrationNumber: string | undefined
  ): Promise<CaseHistoryListItemResponse[]> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/history?";
    if (dealerNumber === null)
      throw new Error("The parameter 'dealerNumber' cannot be null.");
    else if (dealerNumber !== undefined)
      url_ += "dealerNumber=" + encodeURIComponent("" + dealerNumber) + "&";
    if (registrationNumber === null)
      throw new Error("The parameter 'registrationNumber' cannot be null.");
    else if (registrationNumber !== undefined)
      url_ +=
        "registrationNumber=" +
        encodeURIComponent("" + registrationNumber) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionHistoryGET(_response);
    });
  }

  protected processDamageInspectionHistoryGET(
    response: Response
  ): Promise<CaseHistoryListItemResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(CaseHistoryListItemResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CaseHistoryListItemResponse[]>(null as any);
  }

  /**
   * Search for a damage inspection
   * @param dealershipId (optional)
   * @param searchTerm (optional)
   * @param count (optional)
   * @return OK
   */
  damageInspectionSearchGET(
    dealershipId: string | undefined,
    searchTerm: string | undefined,
    count: number | undefined
  ): Promise<DamageInspectionListItemResponse[]> {
    let url_ = this.baseUrl + "/api/v1/damage-inspection/search?";
    if (dealershipId === null)
      throw new Error("The parameter 'dealershipId' cannot be null.");
    else if (dealershipId !== undefined)
      url_ += "dealershipId=" + encodeURIComponent("" + dealershipId) + "&";
    if (searchTerm === null)
      throw new Error("The parameter 'searchTerm' cannot be null.");
    else if (searchTerm !== undefined)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (count === null)
      throw new Error("The parameter 'count' cannot be null.");
    else if (count !== undefined)
      url_ += "count=" + encodeURIComponent("" + count) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDamageInspectionSearchGET(_response);
    });
  }

  protected processDamageInspectionSearchGET(
    response: Response
  ): Promise<DamageInspectionListItemResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DamageInspectionListItemResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DamageInspectionListItemResponse[]>(null as any);
  }

  /**
   * Get material inspection list
   * @param dealershipId (optional)
   * @param count (optional)
   * @return OK
   */
  materialInspectionListGET(
    dealershipId: string | undefined,
    count: number | undefined
  ): Promise<MaterialInspectionListItemResponse[]> {
    let url_ = this.baseUrl + "/api/v1/materialinspection/list?";
    if (dealershipId === null)
      throw new Error("The parameter 'dealershipId' cannot be null.");
    else if (dealershipId !== undefined)
      url_ += "dealershipId=" + encodeURIComponent("" + dealershipId) + "&";
    if (count === null)
      throw new Error("The parameter 'count' cannot be null.");
    else if (count !== undefined)
      url_ += "count=" + encodeURIComponent("" + count) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionListGET(_response);
    });
  }

  protected processMaterialInspectionListGET(
    response: Response
  ): Promise<MaterialInspectionListItemResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(MaterialInspectionListItemResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<MaterialInspectionListItemResponse[]>(null as any);
  }

  /**
   * Get a material inspection
   * @return OK
   */
  materialInspectionGET(id: string): Promise<MaterialInspectionResponse> {
    let url_ = this.baseUrl + "/api/v1/materialinspection/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionGET(_response);
    });
  }

  protected processMaterialInspectionGET(
    response: Response
  ): Promise<MaterialInspectionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MaterialInspectionResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<MaterialInspectionResponse>(null as any);
  }

  /**
   * Update a material inspection
   * @param body (optional)
   * @return OK
   */
  materialInspectionPUT(
    id: string,
    body: UpdateMaterialInspectionRequest | undefined
  ): Promise<MaterialInspectionResponse> {
    let url_ = this.baseUrl + "/api/v1/materialinspection/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionPUT(_response);
    });
  }

  protected processMaterialInspectionPUT(
    response: Response
  ): Promise<MaterialInspectionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MaterialInspectionResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = MaterialInspectionResponse.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<MaterialInspectionResponse>(null as any);
  }

  /**
   * Create a material inspection
   * @param body (optional)
   * @return OK
   */
  materialInspectionPOST(
    body: CreateMaterialInspectionRequest | undefined
  ): Promise<MaterialInspectionResponse> {
    let url_ = this.baseUrl + "/api/v1/materialinspection";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionPOST(_response);
    });
  }

  protected processMaterialInspectionPOST(
    response: Response
  ): Promise<MaterialInspectionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MaterialInspectionResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = MaterialInspectionResponse.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<MaterialInspectionResponse>(null as any);
  }

  /**
   * Get material inspection items
   * @return OK
   */
  materialInspectionItemGET(
    id: string
  ): Promise<MaterialInspectionItemResponse[]> {
    let url_ = this.baseUrl + "/api/v1/materialinspection/{id}/item";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionItemGET(_response);
    });
  }

  protected processMaterialInspectionItemGET(
    response: Response
  ): Promise<MaterialInspectionItemResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(MaterialInspectionItemResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<MaterialInspectionItemResponse[]>(null as any);
  }

  /**
   * Update a material inspection item
   * @param body (optional)
   * @return OK
   */
  materialInspectionItemPUT(
    body: UpdateMaterialInspectionItemRequest | undefined
  ): Promise<MaterialInspectionItemResponse> {
    let url_ = this.baseUrl + "/api/v1/materialinspection/item";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionItemPUT(_response);
    });
  }

  protected processMaterialInspectionItemPUT(
    response: Response
  ): Promise<MaterialInspectionItemResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MaterialInspectionItemResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = MaterialInspectionItemResponse.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<MaterialInspectionItemResponse>(null as any);
  }

  /**
   * Create a material inspection item media relation
   * @param body (optional)
   * @return Created
   */
  materialInspectionItemMediaPOST(
    body: CreateMaterialInspectionItemMediaRequest | undefined
  ): Promise<MaterialInspectionItemMediaResponse> {
    let url_ = this.baseUrl + "/api/v1/materialinspection/item/media";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionItemMediaPOST(_response);
    });
  }

  protected processMaterialInspectionItemMediaPOST(
    response: Response
  ): Promise<MaterialInspectionItemMediaResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = MaterialInspectionItemMediaResponse.fromJS(resultData201);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = MaterialInspectionItemMediaResponse.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<MaterialInspectionItemMediaResponse>(null as any);
  }

  /**
   * Update a material inspection item media
   * @param body (optional)
   * @return OK
   */
  materialInspectionItemMediaPUT(
    body: UpdateMaterialInspectionItemMediaRequest | undefined
  ): Promise<MaterialInspectionItemMediaResponse> {
    let url_ = this.baseUrl + "/api/v1/materialinspection/item/media";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionItemMediaPUT(_response);
    });
  }

  protected processMaterialInspectionItemMediaPUT(
    response: Response
  ): Promise<MaterialInspectionItemMediaResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = MaterialInspectionItemMediaResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = MaterialInspectionItemMediaResponse.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<MaterialInspectionItemMediaResponse>(null as any);
  }

  /**
   * Delete a material inspection item media relation
   * @return No Content
   */
  materialInspectionItemMediaDELETE(id: number): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/materialinspection/item/media/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionItemMediaDELETE(_response);
    });
  }

  protected processMaterialInspectionItemMediaDELETE(
    response: Response
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get material inspection items
   * @param dealerNumber (optional)
   * @param registrationNumber (optional)
   * @return OK
   */
  materialInspectionHistoryGET(
    dealerNumber: string | undefined,
    registrationNumber: string | undefined
  ): Promise<CaseHistoryListItemResponse[]> {
    let url_ = this.baseUrl + "/api/v1/materialinspection/history?";
    if (dealerNumber === null)
      throw new Error("The parameter 'dealerNumber' cannot be null.");
    else if (dealerNumber !== undefined)
      url_ += "dealerNumber=" + encodeURIComponent("" + dealerNumber) + "&";
    if (registrationNumber === null)
      throw new Error("The parameter 'registrationNumber' cannot be null.");
    else if (registrationNumber !== undefined)
      url_ +=
        "registrationNumber=" +
        encodeURIComponent("" + registrationNumber) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionHistoryGET(_response);
    });
  }

  protected processMaterialInspectionHistoryGET(
    response: Response
  ): Promise<CaseHistoryListItemResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(CaseHistoryListItemResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CaseHistoryListItemResponse[]>(null as any);
  }

  /**
   * Search for a material inspection
   * @param dealershipId (optional)
   * @param searchTerm (optional)
   * @param count (optional)
   * @return OK
   */
  materialInspectionSearchGET(
    dealershipId: string | undefined,
    searchTerm: string | undefined,
    count: number | undefined
  ): Promise<MaterialInspectionListItemResponse[]> {
    let url_ = this.baseUrl + "/api/v1/materialinspection/search?";
    if (dealershipId === null)
      throw new Error("The parameter 'dealershipId' cannot be null.");
    else if (dealershipId !== undefined)
      url_ += "dealershipId=" + encodeURIComponent("" + dealershipId) + "&";
    if (searchTerm === null)
      throw new Error("The parameter 'searchTerm' cannot be null.");
    else if (searchTerm !== undefined)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (count === null)
      throw new Error("The parameter 'count' cannot be null.");
    else if (count !== undefined)
      url_ += "count=" + encodeURIComponent("" + count) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMaterialInspectionSearchGET(_response);
    });
  }

  protected processMaterialInspectionSearchGET(
    response: Response
  ): Promise<MaterialInspectionListItemResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(MaterialInspectionListItemResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<MaterialInspectionListItemResponse[]>(null as any);
  }

  /**
   * Upload a file from a form
   * @param files (optional)
   * @param vIN (optional)
   * @param dealerNumber (optional)
   * @param type (optional)
   * @return OK
   */
  mediaPOST(
    files: FileParameter[] | undefined,
    vIN: string | undefined,
    dealerNumber: string | undefined,
    type: MediaTypeEnum | undefined
  ): Promise<string[]> {
    let url_ = this.baseUrl + "/api/v1/media";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (files === null || files === undefined)
      throw new Error("The parameter 'files' cannot be null.");
    else
      files.forEach((item_) =>
        content_.append(
          "files",
          item_.data,
          item_.fileName ? item_.fileName : "files"
        )
      );
    if (vIN === null || vIN === undefined)
      throw new Error("The parameter 'vIN' cannot be null.");
    else content_.append("VIN", vIN.toString());
    if (dealerNumber === null || dealerNumber === undefined)
      throw new Error("The parameter 'dealerNumber' cannot be null.");
    else content_.append("dealerNumber", dealerNumber.toString());
    if (type === null || type === undefined)
      throw new Error("The parameter 'type' cannot be null.");
    else content_.append("type", type.toString());

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMediaPOST(_response);
    });
  }

  protected processMediaPOST(response: Response): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(item);
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status === 415) {
      return response.text().then((_responseText) => {
        let result415: any = null;
        let resultData415 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result415 = ProblemDetails.fromJS(resultData415);
        return throwException(
          "Unsupported Media Type",
          status,
          _responseText,
          _headers,
          result415
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string[]>(null as any);
  }

  /**
   * Gets a file from storage
   * @param type (optional)
   * @return OK
   */
  mediaGET(id: string, type: MediaTypeEnum | undefined): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/media/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMediaGET(_response);
    });
  }

  protected processMediaGET(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers
        };
      });
    } else if (status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers
        };
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Update status of a proposalMediaItem
   * @param body (optional)
   * @return OK
   */
  mediaAddHistoryPOST(body: AddMediaHistoryRequest | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/media/addhistory";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMediaAddHistoryPOST(_response);
    });
  }

  protected processMediaAddHistoryPOST(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Gets a proposal by its Id
   * @return OK
   */
  proposalGET(id: string): Promise<ProposalResponse> {
    let url_ = this.baseUrl + "/api/v1/proposal/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalGET(_response);
    });
  }

  protected processProposalGET(response: Response): Promise<ProposalResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProposalResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalResponse>(null as any);
  }

  /**
   * Soft delete a proposal
   * @return No Content
   */
  proposalDELETE(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/proposal/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalDELETE(_response);
    });
  }

  protected processProposalDELETE(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Not Found", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Gets a filtered list of proposals
   * @param dateFrom (optional)
   * @param dateTo (optional)
   * @param brand (optional)
   * @param searchTerm (optional)
   * @param skip (optional)
   * @param limit (optional)
   * @param statuses (optional)
   * @return OK
   */
  proposalSearchGET(
    dealerNumber: string,
    dateFrom: Date | undefined,
    dateTo: Date | undefined,
    brand: BrandCodeEnum | undefined,
    searchTerm: string | undefined,
    skip: number | undefined,
    limit: number | undefined,
    statuses: ProposalStatusEnum[] | undefined
  ): Promise<SearchProposalResponse> {
    let url_ = this.baseUrl + "/api/v1/proposal/search?";
    if (dealerNumber === undefined || dealerNumber === null)
      throw new Error(
        "The parameter 'dealerNumber' must be defined and cannot be null."
      );
    else url_ += "DealerNumber=" + encodeURIComponent("" + dealerNumber) + "&";
    if (dateFrom === null)
      throw new Error("The parameter 'dateFrom' cannot be null.");
    else if (dateFrom !== undefined)
      url_ +=
        "DateFrom=" +
        encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") +
        "&";
    if (dateTo === null)
      throw new Error("The parameter 'dateTo' cannot be null.");
    else if (dateTo !== undefined)
      url_ +=
        "DateTo=" +
        encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") +
        "&";
    if (brand === null)
      throw new Error("The parameter 'brand' cannot be null.");
    else if (brand !== undefined)
      url_ += "Brand=" + encodeURIComponent("" + brand) + "&";
    if (searchTerm === null)
      throw new Error("The parameter 'searchTerm' cannot be null.");
    else if (searchTerm !== undefined)
      url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (skip === null) throw new Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined)
      url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (statuses === null)
      throw new Error("The parameter 'statuses' cannot be null.");
    else if (statuses !== undefined)
      statuses &&
        statuses.forEach((item) => {
          url_ += "Statuses=" + encodeURIComponent("" + item) + "&";
        });
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalSearchGET(_response);
    });
  }

  protected processProposalSearchGET(
    response: Response
  ): Promise<SearchProposalResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SearchProposalResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SearchProposalResponse>(null as any);
  }

  /**
   * Gets a full length list of proposals
   * @param body (optional)
   * @return OK
   */
  proposalListPOST(
    body: ListProposalsRequest | undefined
  ): Promise<ProposalResponse[]> {
    let url_ = this.baseUrl + "/api/v1/proposal/list";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalListPOST(_response);
    });
  }

  protected processProposalListPOST(
    response: Response
  ): Promise<ProposalResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ProposalResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalResponse[]>(null as any);
  }

  /**
   * Creates an empty proposal with the minimum required props
   * @param body (optional)
   * @return OK
   */
  proposalCreatePOST(body: CreateProposalRequest | undefined): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/proposal/create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalCreatePOST(_response);
    });
  }

  protected processProposalCreatePOST(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Updates the proposal with the provided information
   * @param body (optional)
   * @return OK
   */
  proposalUpdatePOST(body: UpdateProposalRequest | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/proposal/update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalUpdatePOST(_response);
    });
  }

  protected processProposalUpdatePOST(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Sends the vbo proposal and updates its status to sent.
   * @param body (optional)
   * @return OK
   */
  proposalSendPOST(body: SendProposalRequest | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/proposal/send";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalSendPOST(_response);
    });
  }

  protected processProposalSendPOST(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get all available priorities for proposals.
   * @param accept_Language (optional)
   * @return OK
   */
  proposalPrioritiesAllGET(
    accept_Language: string | undefined
  ): Promise<PriorityResponse[]> {
    let url_ = this.baseUrl + "/api/v1/proposal/priorities/all";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        "Accept-Language":
          accept_Language !== undefined && accept_Language !== null
            ? "" + accept_Language
            : "",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalPrioritiesAllGET(_response);
    });
  }

  protected processProposalPrioritiesAllGET(
    response: Response
  ): Promise<PriorityResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PriorityResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PriorityResponse[]>(null as any);
  }

  /**
   * Get a list of status history
   * @return OK
   */
  proposalStatusHistoryGET(
    id: string
  ): Promise<ProposalStatusHistoryResponse[]> {
    let url_ = this.baseUrl + "/api/v1/proposal/{id}/statushistory";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalStatusHistoryGET(_response);
    });
  }

  protected processProposalStatusHistoryGET(
    response: Response
  ): Promise<ProposalStatusHistoryResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ProposalStatusHistoryResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalStatusHistoryResponse[]>(null as any);
  }

  /**
   * Updates the proposal item with the provided information
   * @param body (optional)
   * @return OK
   */
  proposalItemUpdatePOST(
    proposalId: string,
    body: UpdateProposalItemRequest | undefined
  ): Promise<ProposalItemResponse> {
    let url_ = this.baseUrl + "/api/v1/proposal/{proposalId}/item/update";
    if (proposalId === undefined || proposalId === null)
      throw new Error("The parameter 'proposalId' must be defined.");
    url_ = url_.replace("{proposalId}", encodeURIComponent("" + proposalId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalItemUpdatePOST(_response);
    });
  }

  protected processProposalItemUpdatePOST(
    response: Response
  ): Promise<ProposalItemResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProposalItemResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalItemResponse>(null as any);
  }

  /**
   * Get a list of proposal items
   * @return OK
   */
  proposalItemsGET(id: string): Promise<ProposalItemResponse[]> {
    let url_ = this.baseUrl + "/api/v1/proposal/{id}/item";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalItemsGET(_response);
    });
  }

  protected processProposalItemsGET(
    response: Response
  ): Promise<ProposalItemResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ProposalItemResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalItemResponse[]>(null as any);
  }

  /**
   * Get a proposal item
   * @return OK
   */
  proposalItemGET(id: string, itemId: number): Promise<ProposalItemResponse> {
    let url_ = this.baseUrl + "/api/v1/proposal/{id}/item/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalItemGET(_response);
    });
  }

  protected processProposalItemGET(
    response: Response
  ): Promise<ProposalItemResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProposalItemResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProposalItemResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalItemResponse>(null as any);
  }

  /**
   * Create a new proposal item
   * @param body (optional)
   * @return OK
   */
  proposalItemPOST(
    proposalId: string,
    body: CreateProposalItemRequest | undefined
  ): Promise<ProposalItemResponse> {
    let url_ = this.baseUrl + "/api/v1/proposal/{proposalId}/item";
    if (proposalId === undefined || proposalId === null)
      throw new Error("The parameter 'proposalId' must be defined.");
    url_ = url_.replace("{proposalId}", encodeURIComponent("" + proposalId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalItemPOST(_response);
    });
  }

  protected processProposalItemPOST(
    response: Response
  ): Promise<ProposalItemResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProposalItemResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalItemResponse>(null as any);
  }

  /**
   * Create a new proposal item
   * @param body (optional)
   * @return No Content
   */
  proposalItemDeletePOST(
    proposalId: string,
    body: DeleteProposalItemRequest | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/proposal/{proposalId}/item/delete";
    if (proposalId === undefined || proposalId === null)
      throw new Error("The parameter 'proposalId' must be defined.");
    url_ = url_.replace("{proposalId}", encodeURIComponent("" + proposalId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalItemDeletePOST(_response);
    });
  }

  protected processProposalItemDeletePOST(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Not Found", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Get a proposal
   * @return OK
   */
  proposalV2GET(id: string): Promise<ProposalResponseV2> {
    let url_ = this.baseUrl + "/api/v1/proposal/proposalv2/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalV2GET(_response);
    });
  }

  protected processProposalV2GET(
    response: Response
  ): Promise<ProposalResponseV2> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProposalResponseV2.fromJS(resultData200);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ProposalResponseV2.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalResponseV2>(null as any);
  }

  /**
   * Updates the proposal with the provided information
   * @param body (optional)
   * @return OK
   */
  proposalUpdatePOST2(
    body: UpdateProposalRequestV2 | undefined
  ): Promise<ProposalResponseV2> {
    let url_ = this.baseUrl + "/api/v1/proposal/proposalv2";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProposalUpdatePOST2(_response);
    });
  }

  protected processProposalUpdatePOST2(
    response: Response
  ): Promise<ProposalResponseV2> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProposalResponseV2.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProposalResponseV2>(null as any);
  }

  /**
   * Upload a file from a form
   * @param type (optional)
   * @param files (optional)
   * @return OK
   * @deprecated
   */
  create(
    type: MediaTypeEnum | undefined,
    files: FileParameter[] | undefined
  ): Promise<string[]> {
    let url_ = this.baseUrl + "/api/upload/create?";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (files === null || files === undefined)
      throw new Error("The parameter 'files' cannot be null.");
    else
      files.forEach((item_) =>
        content_.append(
          "files",
          item_.data,
          item_.fileName ? item_.fileName : "files"
        )
      );

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreate(_response);
    });
  }

  protected processCreate(response: Response): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(item);
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status === 415) {
      return response.text().then((_responseText) => {
        let result415: any = null;
        let resultData415 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result415 = ProblemDetails.fromJS(resultData415);
        return throwException(
          "Unsupported Media Type",
          status,
          _responseText,
          _headers,
          result415
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string[]>(null as any);
  }

  /**
   * Delete a file from storage
   * @param type (optional)
   * @return OK
   */
  uploadDELETE(id: string, type: MediaTypeEnum | undefined): Promise<string> {
    let url_ = this.baseUrl + "/api/upload/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUploadDELETE(_response);
    });
  }

  protected processUploadDELETE(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Gets a file from storage
   * @param type (optional)
   * @return OK
   * @deprecated
   */
  uploadGET(
    id: string,
    type: MediaTypeEnum | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/upload/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUploadGET(_response);
    });
  }

  protected processUploadGET(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers
        };
      });
    } else if (status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers
        };
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class AddMediaHistoryRequest implements IAddMediaHistoryRequest {
  fileName?: string | undefined;
  status?: string | undefined;
  log?: string | undefined;
  errorMessage?: string | undefined;

  constructor(data?: IAddMediaHistoryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileName = _data["fileName"];
      this.status = _data["status"];
      this.log = _data["log"];
      this.errorMessage = _data["errorMessage"];
    }
  }

  static fromJS(data: any): AddMediaHistoryRequest {
    data = typeof data === "object" ? data : {};
    let result = new AddMediaHistoryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["fileName"] = this.fileName;
    data["status"] = this.status;
    data["log"] = this.log;
    data["errorMessage"] = this.errorMessage;
    return data;
  }
}

export interface IAddMediaHistoryRequest {
  fileName?: string | undefined;
  status?: string | undefined;
  log?: string | undefined;
  errorMessage?: string | undefined;
}

export enum BrandCodeEnum {
  A = "A",
  V = "V",
  S = "S",
  C = "C",
  N = "N",
  P = "P"
}

export class CaseHistoryListItemResponse
  implements ICaseHistoryListItemResponse
{
  id?: string;
  created?: Date;
  dealershipId!: string | undefined;
  workOrderNr?: string | undefined;
  registrationNumber!: string | undefined;
  type!: string | undefined;

  constructor(data?: ICaseHistoryListItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.created = _data["created"]
        ? new Date(_data["created"].toString())
        : <any>undefined;
      this.dealershipId = _data["dealershipId"];
      this.workOrderNr = _data["workOrderNr"];
      this.registrationNumber = _data["registrationNumber"];
      this.type = _data["type"];
    }
  }

  static fromJS(data: any): CaseHistoryListItemResponse {
    data = typeof data === "object" ? data : {};
    let result = new CaseHistoryListItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["created"] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data["dealershipId"] = this.dealershipId;
    data["workOrderNr"] = this.workOrderNr;
    data["registrationNumber"] = this.registrationNumber;
    data["type"] = this.type;
    return data;
  }
}

export interface ICaseHistoryListItemResponse {
  id?: string;
  created?: Date;
  dealershipId: string | undefined;
  workOrderNr?: string | undefined;
  registrationNumber: string | undefined;
  type: string | undefined;
}

export class CreateDamageInspectionItemMediaRequest
  implements ICreateDamageInspectionItemMediaRequest
{
  itemId?: number;
  mediaName!: string | undefined;
  mediaType!: MediaTypeEnum;

  constructor(data?: ICreateDamageInspectionItemMediaRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.itemId = _data["itemId"];
      this.mediaName = _data["mediaName"];
      this.mediaType = _data["mediaType"];
    }
  }

  static fromJS(data: any): CreateDamageInspectionItemMediaRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateDamageInspectionItemMediaRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["itemId"] = this.itemId;
    data["mediaName"] = this.mediaName;
    data["mediaType"] = this.mediaType;
    return data;
  }
}

export interface ICreateDamageInspectionItemMediaRequest {
  itemId?: number;
  mediaName: string | undefined;
  mediaType: MediaTypeEnum;
}

export class CreateDamageInspectionItemRequest
  implements ICreateDamageInspectionItemRequest
{
  title?: string | undefined;

  constructor(data?: ICreateDamageInspectionItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data["title"];
    }
  }

  static fromJS(data: any): CreateDamageInspectionItemRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateDamageInspectionItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["title"] = this.title;
    return data;
  }
}

export interface ICreateDamageInspectionItemRequest {
  title?: string | undefined;
}

export class CreateDamageInspectionRequest
  implements ICreateDamageInspectionRequest
{
  createdBy!: string | undefined;
  createdById!: string | undefined;
  dealershipId!: string | undefined;
  workOrderNr?: string | undefined;
  registrationNumber!: string | undefined;
  vin!: string | undefined;
  modelText?: string | undefined;
  brandCode!: BrandCodeEnum;

  constructor(data?: ICreateDamageInspectionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdBy = _data["createdBy"];
      this.createdById = _data["createdById"];
      this.dealershipId = _data["dealershipId"];
      this.workOrderNr = _data["workOrderNr"];
      this.registrationNumber = _data["registrationNumber"];
      this.vin = _data["vin"];
      this.modelText = _data["modelText"];
      this.brandCode = _data["brandCode"];
    }
  }

  static fromJS(data: any): CreateDamageInspectionRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateDamageInspectionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["createdBy"] = this.createdBy;
    data["createdById"] = this.createdById;
    data["dealershipId"] = this.dealershipId;
    data["workOrderNr"] = this.workOrderNr;
    data["registrationNumber"] = this.registrationNumber;
    data["vin"] = this.vin;
    data["modelText"] = this.modelText;
    data["brandCode"] = this.brandCode;
    return data;
  }
}

export interface ICreateDamageInspectionRequest {
  createdBy: string | undefined;
  createdById: string | undefined;
  dealershipId: string | undefined;
  workOrderNr?: string | undefined;
  registrationNumber: string | undefined;
  vin: string | undefined;
  modelText?: string | undefined;
  brandCode: BrandCodeEnum;
}

export class CreateMaterialInspectionItemMediaRequest
  implements ICreateMaterialInspectionItemMediaRequest
{
  itemId?: number;
  mediaName!: string | undefined;
  mediaType!: MediaTypeEnum;

  constructor(data?: ICreateMaterialInspectionItemMediaRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.itemId = _data["itemId"];
      this.mediaName = _data["mediaName"];
      this.mediaType = _data["mediaType"];
    }
  }

  static fromJS(data: any): CreateMaterialInspectionItemMediaRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateMaterialInspectionItemMediaRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["itemId"] = this.itemId;
    data["mediaName"] = this.mediaName;
    data["mediaType"] = this.mediaType;
    return data;
  }
}

export interface ICreateMaterialInspectionItemMediaRequest {
  itemId?: number;
  mediaName: string | undefined;
  mediaType: MediaTypeEnum;
}

export class CreateMaterialInspectionRequest
  implements ICreateMaterialInspectionRequest
{
  createdBy!: string | undefined;
  createdById!: string | undefined;
  dealershipId!: string | undefined;
  workOrderNr?: string | undefined;
  registrationNumber!: string | undefined;
  vin!: string | undefined;
  modelText?: string | undefined;
  brandCode!: BrandCodeEnum;

  constructor(data?: ICreateMaterialInspectionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdBy = _data["createdBy"];
      this.createdById = _data["createdById"];
      this.dealershipId = _data["dealershipId"];
      this.workOrderNr = _data["workOrderNr"];
      this.registrationNumber = _data["registrationNumber"];
      this.vin = _data["vin"];
      this.modelText = _data["modelText"];
      this.brandCode = _data["brandCode"];
    }
  }

  static fromJS(data: any): CreateMaterialInspectionRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateMaterialInspectionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["createdBy"] = this.createdBy;
    data["createdById"] = this.createdById;
    data["dealershipId"] = this.dealershipId;
    data["workOrderNr"] = this.workOrderNr;
    data["registrationNumber"] = this.registrationNumber;
    data["vin"] = this.vin;
    data["modelText"] = this.modelText;
    data["brandCode"] = this.brandCode;
    return data;
  }
}

export interface ICreateMaterialInspectionRequest {
  createdBy: string | undefined;
  createdById: string | undefined;
  dealershipId: string | undefined;
  workOrderNr?: string | undefined;
  registrationNumber: string | undefined;
  vin: string | undefined;
  modelText?: string | undefined;
  brandCode: BrandCodeEnum;
}

export class CreateProposalItemRequest implements ICreateProposalItemRequest {
  createdById!: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price?: number;
  requiredTime?: number;
  packages?: ProposalMediaPackageRequest[] | undefined;
  medias?: ProposalMediaRequest[] | undefined;
  customerAccepted?: boolean | undefined;

  constructor(data?: ICreateProposalItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdById = _data["createdById"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.priorityId = _data["priorityId"];
      this.price = _data["price"];
      this.requiredTime = _data["requiredTime"];
      if (Array.isArray(_data["packages"])) {
        this.packages = [] as any;
        for (let item of _data["packages"])
          this.packages!.push(ProposalMediaPackageRequest.fromJS(item));
      }
      if (Array.isArray(_data["medias"])) {
        this.medias = [] as any;
        for (let item of _data["medias"])
          this.medias!.push(ProposalMediaRequest.fromJS(item));
      }
      this.customerAccepted = _data["customerAccepted"];
    }
  }

  static fromJS(data: any): CreateProposalItemRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateProposalItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["createdById"] = this.createdById;
    data["name"] = this.name;
    data["description"] = this.description;
    data["priorityId"] = this.priorityId;
    data["price"] = this.price;
    data["requiredTime"] = this.requiredTime;
    if (Array.isArray(this.packages)) {
      data["packages"] = [];
      for (let item of this.packages) data["packages"].push(item.toJSON());
    }
    if (Array.isArray(this.medias)) {
      data["medias"] = [];
      for (let item of this.medias) data["medias"].push(item.toJSON());
    }
    data["customerAccepted"] = this.customerAccepted;
    return data;
  }
}

export interface ICreateProposalItemRequest {
  createdById: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price?: number;
  requiredTime?: number;
  packages?: ProposalMediaPackageRequest[] | undefined;
  medias?: ProposalMediaRequest[] | undefined;
  customerAccepted?: boolean | undefined;
}

export class CreateProposalRequest implements ICreateProposalRequest {
  createdBy!: string;
  dealer!: string;
  workOrderId?: string | undefined;
  chassiNumber!: string;
  registrationNumber!: string;
  modelText!: string;
  brand!: BrandCodeEnum;

  constructor(data?: ICreateProposalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdBy = _data["createdBy"];
      this.dealer = _data["dealer"];
      this.workOrderId = _data["workOrderId"];
      this.chassiNumber = _data["chassiNumber"];
      this.registrationNumber = _data["registrationNumber"];
      this.modelText = _data["modelText"];
      this.brand = _data["brand"];
    }
  }

  static fromJS(data: any): CreateProposalRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateProposalRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["createdBy"] = this.createdBy;
    data["dealer"] = this.dealer;
    data["workOrderId"] = this.workOrderId;
    data["chassiNumber"] = this.chassiNumber;
    data["registrationNumber"] = this.registrationNumber;
    data["modelText"] = this.modelText;
    data["brand"] = this.brand;
    return data;
  }
}

export interface ICreateProposalRequest {
  createdBy: string;
  dealer: string;
  workOrderId?: string | undefined;
  chassiNumber: string;
  registrationNumber: string;
  modelText: string;
  brand: BrandCodeEnum;
}

export class CustomerResponseRequest implements ICustomerResponseRequest {
  proposalId!: string;
  acceptedItemIds!: number[];

  constructor(data?: ICustomerResponseRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.acceptedItemIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.proposalId = _data["proposalId"];
      if (Array.isArray(_data["acceptedItemIds"])) {
        this.acceptedItemIds = [] as any;
        for (let item of _data["acceptedItemIds"])
          this.acceptedItemIds!.push(item);
      }
    }
  }

  static fromJS(data: any): CustomerResponseRequest {
    data = typeof data === "object" ? data : {};
    let result = new CustomerResponseRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["proposalId"] = this.proposalId;
    if (Array.isArray(this.acceptedItemIds)) {
      data["acceptedItemIds"] = [];
      for (let item of this.acceptedItemIds) data["acceptedItemIds"].push(item);
    }
    return data;
  }
}

export interface ICustomerResponseRequest {
  proposalId: string;
  acceptedItemIds: number[];
}

export class CustomerVehicleResponse implements ICustomerVehicleResponse {
  chassi?: string | undefined;
  registrationNumber?: string | undefined;
  modelText?: string | undefined;
  brand?: BrandCodeEnum;

  constructor(data?: ICustomerVehicleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.chassi = _data["chassi"];
      this.registrationNumber = _data["registrationNumber"];
      this.modelText = _data["modelText"];
      this.brand = _data["brand"];
    }
  }

  static fromJS(data: any): CustomerVehicleResponse {
    data = typeof data === "object" ? data : {};
    let result = new CustomerVehicleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["chassi"] = this.chassi;
    data["registrationNumber"] = this.registrationNumber;
    data["modelText"] = this.modelText;
    data["brand"] = this.brand;
    return data;
  }
}

export interface ICustomerVehicleResponse {
  chassi?: string | undefined;
  registrationNumber?: string | undefined;
  modelText?: string | undefined;
  brand?: BrandCodeEnum;
}

export class CustomerViewCustomerResponse
  implements ICustomerViewCustomerResponse
{
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;

  constructor(data?: ICustomerViewCustomerResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.phone = _data["phone"];
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): CustomerViewCustomerResponse {
    data = typeof data === "object" ? data : {};
    let result = new CustomerViewCustomerResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["phone"] = this.phone;
    data["email"] = this.email;
    return data;
  }
}

export interface ICustomerViewCustomerResponse {
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
}

export class CustomerViewItemResponse implements ICustomerViewItemResponse {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
  priority?: string | undefined;
  price?: number;
  latestResponseTime?: Date | undefined;
  customerAccepted?: boolean | undefined;
  packages?: CustomerViewMediaPackageResponse[] | undefined;
  medias?: CustomerViewMediaResponse[] | undefined;

  constructor(data?: ICustomerViewItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.priority = _data["priority"];
      this.price = _data["price"];
      this.latestResponseTime = _data["latestResponseTime"]
        ? new Date(_data["latestResponseTime"].toString())
        : <any>undefined;
      this.customerAccepted = _data["customerAccepted"];
      if (Array.isArray(_data["packages"])) {
        this.packages = [] as any;
        for (let item of _data["packages"])
          this.packages!.push(CustomerViewMediaPackageResponse.fromJS(item));
      }
      if (Array.isArray(_data["medias"])) {
        this.medias = [] as any;
        for (let item of _data["medias"])
          this.medias!.push(CustomerViewMediaResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CustomerViewItemResponse {
    data = typeof data === "object" ? data : {};
    let result = new CustomerViewItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    data["priority"] = this.priority;
    data["price"] = this.price;
    data["latestResponseTime"] = this.latestResponseTime
      ? this.latestResponseTime.toISOString()
      : <any>undefined;
    data["customerAccepted"] = this.customerAccepted;
    if (Array.isArray(this.packages)) {
      data["packages"] = [];
      for (let item of this.packages) data["packages"].push(item.toJSON());
    }
    if (Array.isArray(this.medias)) {
      data["medias"] = [];
      for (let item of this.medias) data["medias"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICustomerViewItemResponse {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
  priority?: string | undefined;
  price?: number;
  latestResponseTime?: Date | undefined;
  customerAccepted?: boolean | undefined;
  packages?: CustomerViewMediaPackageResponse[] | undefined;
  medias?: CustomerViewMediaResponse[] | undefined;
}

export class CustomerViewMediaPackageResponse
  implements ICustomerViewMediaPackageResponse
{
  id?: number | undefined;
  price?: number;
  externalPackageId?: string | undefined;

  constructor(data?: ICustomerViewMediaPackageResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.price = _data["price"];
      this.externalPackageId = _data["externalPackageId"];
    }
  }

  static fromJS(data: any): CustomerViewMediaPackageResponse {
    data = typeof data === "object" ? data : {};
    let result = new CustomerViewMediaPackageResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["price"] = this.price;
    data["externalPackageId"] = this.externalPackageId;
    return data;
  }
}

export interface ICustomerViewMediaPackageResponse {
  id?: number | undefined;
  price?: number;
  externalPackageId?: string | undefined;
}

export class CustomerViewMediaResponse implements ICustomerViewMediaResponse {
  id?: number | undefined;
  mediaType?: MediaTypeEnum;
  mediaUrl?: string | undefined;
  priorityAsc?: number;
  originalFilename?: string | undefined;

  constructor(data?: ICustomerViewMediaResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.mediaType = _data["mediaType"];
      this.mediaUrl = _data["mediaUrl"];
      this.priorityAsc = _data["priorityAsc"];
      this.originalFilename = _data["originalFilename"];
    }
  }

  static fromJS(data: any): CustomerViewMediaResponse {
    data = typeof data === "object" ? data : {};
    let result = new CustomerViewMediaResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["mediaType"] = this.mediaType;
    data["mediaUrl"] = this.mediaUrl;
    data["priorityAsc"] = this.priorityAsc;
    data["originalFilename"] = this.originalFilename;
    return data;
  }
}

export interface ICustomerViewMediaResponse {
  id?: number | undefined;
  mediaType?: MediaTypeEnum;
  mediaUrl?: string | undefined;
  priorityAsc?: number;
  originalFilename?: string | undefined;
}

export class CustomerViewResponse implements ICustomerViewResponse {
  id?: string;
  status?: ProposalStatusEnum;
  dealerNumber?: string | undefined;
  mechanicName?: string | undefined;
  advisorName?: string | undefined;
  proposalItems?: CustomerViewItemResponse[] | undefined;
  proposalVehicle?: CustomerVehicleResponse;
  proposalCustomer?: CustomerViewCustomerResponse;

  constructor(data?: ICustomerViewResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.status = _data["status"];
      this.dealerNumber = _data["dealerNumber"];
      this.mechanicName = _data["mechanicName"];
      this.advisorName = _data["advisorName"];
      if (Array.isArray(_data["proposalItems"])) {
        this.proposalItems = [] as any;
        for (let item of _data["proposalItems"])
          this.proposalItems!.push(CustomerViewItemResponse.fromJS(item));
      }
      this.proposalVehicle = _data["proposalVehicle"]
        ? CustomerVehicleResponse.fromJS(_data["proposalVehicle"])
        : <any>undefined;
      this.proposalCustomer = _data["proposalCustomer"]
        ? CustomerViewCustomerResponse.fromJS(_data["proposalCustomer"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CustomerViewResponse {
    data = typeof data === "object" ? data : {};
    let result = new CustomerViewResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["status"] = this.status;
    data["dealerNumber"] = this.dealerNumber;
    data["mechanicName"] = this.mechanicName;
    data["advisorName"] = this.advisorName;
    if (Array.isArray(this.proposalItems)) {
      data["proposalItems"] = [];
      for (let item of this.proposalItems)
        data["proposalItems"].push(item.toJSON());
    }
    data["proposalVehicle"] = this.proposalVehicle
      ? this.proposalVehicle.toJSON()
      : <any>undefined;
    data["proposalCustomer"] = this.proposalCustomer
      ? this.proposalCustomer.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface ICustomerViewResponse {
  id?: string;
  status?: ProposalStatusEnum;
  dealerNumber?: string | undefined;
  mechanicName?: string | undefined;
  advisorName?: string | undefined;
  proposalItems?: CustomerViewItemResponse[] | undefined;
  proposalVehicle?: CustomerVehicleResponse;
  proposalCustomer?: CustomerViewCustomerResponse;
}

export class DamageInspectionItemMediaResponse
  implements IDamageInspectionItemMediaResponse
{
  id?: number;
  damageInspectionItemId?: number;
  mediaName!: string | undefined;
  mediaType!: MediaTypeEnum;

  constructor(data?: IDamageInspectionItemMediaResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.damageInspectionItemId = _data["damageInspectionItemId"];
      this.mediaName = _data["mediaName"];
      this.mediaType = _data["mediaType"];
    }
  }

  static fromJS(data: any): DamageInspectionItemMediaResponse {
    data = typeof data === "object" ? data : {};
    let result = new DamageInspectionItemMediaResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["damageInspectionItemId"] = this.damageInspectionItemId;
    data["mediaName"] = this.mediaName;
    data["mediaType"] = this.mediaType;
    return data;
  }
}

export interface IDamageInspectionItemMediaResponse {
  id?: number;
  damageInspectionItemId?: number;
  mediaName: string | undefined;
  mediaType: MediaTypeEnum;
}

export class DamageInspectionItemResponse
  implements IDamageInspectionItemResponse
{
  id?: number;
  title?: string | undefined;
  media?: DamageInspectionItemMediaResponse[] | undefined;

  constructor(data?: IDamageInspectionItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
      if (Array.isArray(_data["media"])) {
        this.media = [] as any;
        for (let item of _data["media"])
          this.media!.push(DamageInspectionItemMediaResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DamageInspectionItemResponse {
    data = typeof data === "object" ? data : {};
    let result = new DamageInspectionItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    if (Array.isArray(this.media)) {
      data["media"] = [];
      for (let item of this.media) data["media"].push(item.toJSON());
    }
    return data;
  }
}

export interface IDamageInspectionItemResponse {
  id?: number;
  title?: string | undefined;
  media?: DamageInspectionItemMediaResponse[] | undefined;
}

export class DamageInspectionListItemResponse
  implements IDamageInspectionListItemResponse
{
  id?: string;
  registrationNumber!: string | undefined;
  workOrderNr?: string | undefined;
  created?: Date;
  brandCode?: BrandCodeEnum;
  isReviewed?: boolean;

  constructor(data?: IDamageInspectionListItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.registrationNumber = _data["registrationNumber"];
      this.workOrderNr = _data["workOrderNr"];
      this.created = _data["created"]
        ? new Date(_data["created"].toString())
        : <any>undefined;
      this.brandCode = _data["brandCode"];
      this.isReviewed = _data["isReviewed"];
    }
  }

  static fromJS(data: any): DamageInspectionListItemResponse {
    data = typeof data === "object" ? data : {};
    let result = new DamageInspectionListItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["registrationNumber"] = this.registrationNumber;
    data["workOrderNr"] = this.workOrderNr;
    data["created"] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data["brandCode"] = this.brandCode;
    data["isReviewed"] = this.isReviewed;
    return data;
  }
}

export interface IDamageInspectionListItemResponse {
  id?: string;
  registrationNumber: string | undefined;
  workOrderNr?: string | undefined;
  created?: Date;
  brandCode?: BrandCodeEnum;
  isReviewed?: boolean;
}

export class DamageInspectionResponse implements IDamageInspectionResponse {
  id?: string;
  created?: Date;
  createdBy!: string | undefined;
  createdById!: string | undefined;
  reviewedBy?: string | undefined;
  dealershipId!: string | undefined;
  workOrderNr?: string | undefined;
  registrationNumber!: string | undefined;
  vin!: string | undefined;
  modelText?: string | undefined;
  brandCode!: BrandCodeEnum;
  isReviewed?: boolean;

  constructor(data?: IDamageInspectionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.created = _data["created"]
        ? new Date(_data["created"].toString())
        : <any>undefined;
      this.createdBy = _data["createdBy"];
      this.createdById = _data["createdById"];
      this.reviewedBy = _data["reviewedBy"];
      this.dealershipId = _data["dealershipId"];
      this.workOrderNr = _data["workOrderNr"];
      this.registrationNumber = _data["registrationNumber"];
      this.vin = _data["vin"];
      this.modelText = _data["modelText"];
      this.brandCode = _data["brandCode"];
      this.isReviewed = _data["isReviewed"];
    }
  }

  static fromJS(data: any): DamageInspectionResponse {
    data = typeof data === "object" ? data : {};
    let result = new DamageInspectionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["created"] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data["createdBy"] = this.createdBy;
    data["createdById"] = this.createdById;
    data["reviewedBy"] = this.reviewedBy;
    data["dealershipId"] = this.dealershipId;
    data["workOrderNr"] = this.workOrderNr;
    data["registrationNumber"] = this.registrationNumber;
    data["vin"] = this.vin;
    data["modelText"] = this.modelText;
    data["brandCode"] = this.brandCode;
    data["isReviewed"] = this.isReviewed;
    return data;
  }
}

export interface IDamageInspectionResponse {
  id?: string;
  created?: Date;
  createdBy: string | undefined;
  createdById: string | undefined;
  reviewedBy?: string | undefined;
  dealershipId: string | undefined;
  workOrderNr?: string | undefined;
  registrationNumber: string | undefined;
  vin: string | undefined;
  modelText?: string | undefined;
  brandCode: BrandCodeEnum;
  isReviewed?: boolean;
}

export class DeleteProposalItemRequest implements IDeleteProposalItemRequest {
  createdById!: string | undefined;
  id!: number;

  constructor(data?: IDeleteProposalItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdById = _data["createdById"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): DeleteProposalItemRequest {
    data = typeof data === "object" ? data : {};
    let result = new DeleteProposalItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["createdById"] = this.createdById;
    data["id"] = this.id;
    return data;
  }
}

export interface IDeleteProposalItemRequest {
  createdById: string | undefined;
  id: number;
}

export class ListProposalsRequest implements IListProposalsRequest {
  dealer!: string;
  statuses?: ProposalStatusEnum[] | undefined;
  status?: ProposalStatusEnum;

  constructor(data?: IListProposalsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dealer = _data["dealer"];
      if (Array.isArray(_data["statuses"])) {
        this.statuses = [] as any;
        for (let item of _data["statuses"]) this.statuses!.push(item);
      }
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): ListProposalsRequest {
    data = typeof data === "object" ? data : {};
    let result = new ListProposalsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dealer"] = this.dealer;
    if (Array.isArray(this.statuses)) {
      data["statuses"] = [];
      for (let item of this.statuses) data["statuses"].push(item);
    }
    data["status"] = this.status;
    return data;
  }
}

export interface IListProposalsRequest {
  dealer: string;
  statuses?: ProposalStatusEnum[] | undefined;
  status?: ProposalStatusEnum;
}

export class MaterialInspectionItemMediaResponse
  implements IMaterialInspectionItemMediaResponse
{
  id?: number;
  materialInspectionItemId?: number;
  mediaName!: string | undefined;
  mediaType!: MediaTypeEnum;

  constructor(data?: IMaterialInspectionItemMediaResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.materialInspectionItemId = _data["materialInspectionItemId"];
      this.mediaName = _data["mediaName"];
      this.mediaType = _data["mediaType"];
    }
  }

  static fromJS(data: any): MaterialInspectionItemMediaResponse {
    data = typeof data === "object" ? data : {};
    let result = new MaterialInspectionItemMediaResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["materialInspectionItemId"] = this.materialInspectionItemId;
    data["mediaName"] = this.mediaName;
    data["mediaType"] = this.mediaType;
    return data;
  }
}

export interface IMaterialInspectionItemMediaResponse {
  id?: number;
  materialInspectionItemId?: number;
  mediaName: string | undefined;
  mediaType: MediaTypeEnum;
}

export class MaterialInspectionItemResponse
  implements IMaterialInspectionItemResponse
{
  id?: number;
  title?: string | undefined;
  media?: MaterialInspectionItemMediaResponse[] | undefined;

  constructor(data?: IMaterialInspectionItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
      if (Array.isArray(_data["media"])) {
        this.media = [] as any;
        for (let item of _data["media"])
          this.media!.push(MaterialInspectionItemMediaResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MaterialInspectionItemResponse {
    data = typeof data === "object" ? data : {};
    let result = new MaterialInspectionItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    if (Array.isArray(this.media)) {
      data["media"] = [];
      for (let item of this.media) data["media"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMaterialInspectionItemResponse {
  id?: number;
  title?: string | undefined;
  media?: MaterialInspectionItemMediaResponse[] | undefined;
}

export class MaterialInspectionListItemResponse
  implements IMaterialInspectionListItemResponse
{
  id?: string;
  registrationNumber!: string | undefined;
  workOrderNr?: string | undefined;
  created?: Date;
  brandCode?: BrandCodeEnum;
  isReviewed?: boolean;

  constructor(data?: IMaterialInspectionListItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.registrationNumber = _data["registrationNumber"];
      this.workOrderNr = _data["workOrderNr"];
      this.created = _data["created"]
        ? new Date(_data["created"].toString())
        : <any>undefined;
      this.brandCode = _data["brandCode"];
      this.isReviewed = _data["isReviewed"];
    }
  }

  static fromJS(data: any): MaterialInspectionListItemResponse {
    data = typeof data === "object" ? data : {};
    let result = new MaterialInspectionListItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["registrationNumber"] = this.registrationNumber;
    data["workOrderNr"] = this.workOrderNr;
    data["created"] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data["brandCode"] = this.brandCode;
    data["isReviewed"] = this.isReviewed;
    return data;
  }
}

export interface IMaterialInspectionListItemResponse {
  id?: string;
  registrationNumber: string | undefined;
  workOrderNr?: string | undefined;
  created?: Date;
  brandCode?: BrandCodeEnum;
  isReviewed?: boolean;
}

export class MaterialInspectionResponse implements IMaterialInspectionResponse {
  id!: string;
  created?: Date;
  createdBy!: string | undefined;
  createdById!: string | undefined;
  reviewedBy?: string | undefined;
  dealershipId!: string | undefined;
  workOrderNr?: string | undefined;
  vin!: string | undefined;
  registrationNumber!: string | undefined;
  modelText?: string | undefined;
  brandCode!: BrandCodeEnum;
  isReviewed?: boolean;
  hasConfirmedMediaForAllSteps?: boolean;

  constructor(data?: IMaterialInspectionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.created = _data["created"]
        ? new Date(_data["created"].toString())
        : <any>undefined;
      this.createdBy = _data["createdBy"];
      this.createdById = _data["createdById"];
      this.reviewedBy = _data["reviewedBy"];
      this.dealershipId = _data["dealershipId"];
      this.workOrderNr = _data["workOrderNr"];
      this.vin = _data["vin"];
      this.registrationNumber = _data["registrationNumber"];
      this.modelText = _data["modelText"];
      this.brandCode = _data["brandCode"];
      this.isReviewed = _data["isReviewed"];
      this.hasConfirmedMediaForAllSteps = _data["hasConfirmedMediaForAllSteps"];
    }
  }

  static fromJS(data: any): MaterialInspectionResponse {
    data = typeof data === "object" ? data : {};
    let result = new MaterialInspectionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["created"] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data["createdBy"] = this.createdBy;
    data["createdById"] = this.createdById;
    data["reviewedBy"] = this.reviewedBy;
    data["dealershipId"] = this.dealershipId;
    data["workOrderNr"] = this.workOrderNr;
    data["vin"] = this.vin;
    data["registrationNumber"] = this.registrationNumber;
    data["modelText"] = this.modelText;
    data["brandCode"] = this.brandCode;
    data["isReviewed"] = this.isReviewed;
    data["hasConfirmedMediaForAllSteps"] = this.hasConfirmedMediaForAllSteps;
    return data;
  }
}

export interface IMaterialInspectionResponse {
  id: string;
  created?: Date;
  createdBy: string | undefined;
  createdById: string | undefined;
  reviewedBy?: string | undefined;
  dealershipId: string | undefined;
  workOrderNr?: string | undefined;
  vin: string | undefined;
  registrationNumber: string | undefined;
  modelText?: string | undefined;
  brandCode: BrandCodeEnum;
  isReviewed?: boolean;
  hasConfirmedMediaForAllSteps?: boolean;
}

export enum MediaTypeEnum {
  Video = "Video",
  Image = "Image",
  Note = "Note"
}

export class PriorityResponse implements IPriorityResponse {
  id!: number;
  name!: string | undefined;
  value!: number;
  description!: string | undefined;

  constructor(data?: IPriorityResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.value = _data["value"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): PriorityResponse {
    data = typeof data === "object" ? data : {};
    let result = new PriorityResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["value"] = this.value;
    data["description"] = this.description;
    return data;
  }
}

export interface IPriorityResponse {
  id: number;
  name: string | undefined;
  value: number;
  description: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class ProposalCustomerRequest implements IProposalCustomerRequest {
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;

  constructor(data?: IProposalCustomerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.phone = _data["phone"];
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): ProposalCustomerRequest {
    data = typeof data === "object" ? data : {};
    let result = new ProposalCustomerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["phone"] = this.phone;
    data["email"] = this.email;
    return data;
  }
}

export interface IProposalCustomerRequest {
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
}

export class ProposalCustomerResponse implements IProposalCustomerResponse {
  firstName!: string;
  lastName!: string;
  phone?: string | undefined;
  email?: string | undefined;

  constructor(data?: IProposalCustomerResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.phone = _data["phone"];
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): ProposalCustomerResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalCustomerResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["phone"] = this.phone;
    data["email"] = this.email;
    return data;
  }
}

export interface IProposalCustomerResponse {
  firstName: string;
  lastName: string;
  phone?: string | undefined;
  email?: string | undefined;
}

export class ProposalItemRequest implements IProposalItemRequest {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price?: number;
  requiredTime?: number;
  packages?: ProposalMediaPackageRequest[] | undefined;
  medias?: ProposalMediaRequest[] | undefined;
  customerAccepted?: boolean | undefined;
  status?: ProposalItemStatus;

  constructor(data?: IProposalItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.priorityId = _data["priorityId"];
      this.price = _data["price"];
      this.requiredTime = _data["requiredTime"];
      if (Array.isArray(_data["packages"])) {
        this.packages = [] as any;
        for (let item of _data["packages"])
          this.packages!.push(ProposalMediaPackageRequest.fromJS(item));
      }
      if (Array.isArray(_data["medias"])) {
        this.medias = [] as any;
        for (let item of _data["medias"])
          this.medias!.push(ProposalMediaRequest.fromJS(item));
      }
      this.customerAccepted = _data["customerAccepted"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): ProposalItemRequest {
    data = typeof data === "object" ? data : {};
    let result = new ProposalItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    data["priorityId"] = this.priorityId;
    data["price"] = this.price;
    data["requiredTime"] = this.requiredTime;
    if (Array.isArray(this.packages)) {
      data["packages"] = [];
      for (let item of this.packages) data["packages"].push(item.toJSON());
    }
    if (Array.isArray(this.medias)) {
      data["medias"] = [];
      for (let item of this.medias) data["medias"].push(item.toJSON());
    }
    data["customerAccepted"] = this.customerAccepted;
    data["status"] = this.status;
    return data;
  }
}

export interface IProposalItemRequest {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price?: number;
  requiredTime?: number;
  packages?: ProposalMediaPackageRequest[] | undefined;
  medias?: ProposalMediaRequest[] | undefined;
  customerAccepted?: boolean | undefined;
  status?: ProposalItemStatus;
}

export class ProposalItemResponse implements IProposalItemResponse {
  id!: number;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price!: number;
  requiredTime!: number;
  latestResponseTime?: Date | undefined;
  packages!: ProposalMediaPackageResponse[];
  medias!: ProposalMediaResponse[];
  customerAccepted?: boolean | undefined;
  status?: ProposalItemStatus;

  constructor(data?: IProposalItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.packages = [];
      this.medias = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.priorityId = _data["priorityId"];
      this.price = _data["price"];
      this.requiredTime = _data["requiredTime"];
      this.latestResponseTime = _data["latestResponseTime"]
        ? new Date(_data["latestResponseTime"].toString())
        : <any>undefined;
      if (Array.isArray(_data["packages"])) {
        this.packages = [] as any;
        for (let item of _data["packages"])
          this.packages!.push(ProposalMediaPackageResponse.fromJS(item));
      }
      if (Array.isArray(_data["medias"])) {
        this.medias = [] as any;
        for (let item of _data["medias"])
          this.medias!.push(ProposalMediaResponse.fromJS(item));
      }
      this.customerAccepted = _data["customerAccepted"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): ProposalItemResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    data["priorityId"] = this.priorityId;
    data["price"] = this.price;
    data["requiredTime"] = this.requiredTime;
    data["latestResponseTime"] = this.latestResponseTime
      ? this.latestResponseTime.toISOString()
      : <any>undefined;
    if (Array.isArray(this.packages)) {
      data["packages"] = [];
      for (let item of this.packages) data["packages"].push(item.toJSON());
    }
    if (Array.isArray(this.medias)) {
      data["medias"] = [];
      for (let item of this.medias) data["medias"].push(item.toJSON());
    }
    data["customerAccepted"] = this.customerAccepted;
    data["status"] = this.status;
    return data;
  }
}

export interface IProposalItemResponse {
  id: number;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price: number;
  requiredTime: number;
  latestResponseTime?: Date | undefined;
  packages: ProposalMediaPackageResponse[];
  medias: ProposalMediaResponse[];
  customerAccepted?: boolean | undefined;
  status?: ProposalItemStatus;
}

export enum ProposalItemStatus {
  New = "New",
  Closed = "Closed",
  ClosedWithSale = "ClosedWithSale"
}

export class ProposalMediaPackageRequest
  implements IProposalMediaPackageRequest
{
  id?: number | undefined;
  price?: number;
  externalPackageId?: string | undefined;

  constructor(data?: IProposalMediaPackageRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.price = _data["price"];
      this.externalPackageId = _data["externalPackageId"];
    }
  }

  static fromJS(data: any): ProposalMediaPackageRequest {
    data = typeof data === "object" ? data : {};
    let result = new ProposalMediaPackageRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["price"] = this.price;
    data["externalPackageId"] = this.externalPackageId;
    return data;
  }
}

export interface IProposalMediaPackageRequest {
  id?: number | undefined;
  price?: number;
  externalPackageId?: string | undefined;
}

export class ProposalMediaPackageResponse
  implements IProposalMediaPackageResponse
{
  id?: number | undefined;
  price!: number;
  externalPackageId!: string;

  constructor(data?: IProposalMediaPackageResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.price = _data["price"];
      this.externalPackageId = _data["externalPackageId"];
    }
  }

  static fromJS(data: any): ProposalMediaPackageResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalMediaPackageResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["price"] = this.price;
    data["externalPackageId"] = this.externalPackageId;
    return data;
  }
}

export interface IProposalMediaPackageResponse {
  id?: number | undefined;
  price: number;
  externalPackageId: string;
}

export class ProposalMediaRequest implements IProposalMediaRequest {
  id?: number | undefined;
  mediaType?: MediaTypeEnum;
  mediaUrl?: string | undefined;
  originalFilename?: string | undefined;
  priorityAsc?: number;

  constructor(data?: IProposalMediaRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.mediaType = _data["mediaType"];
      this.mediaUrl = _data["mediaUrl"];
      this.originalFilename = _data["originalFilename"];
      this.priorityAsc = _data["priorityAsc"];
    }
  }

  static fromJS(data: any): ProposalMediaRequest {
    data = typeof data === "object" ? data : {};
    let result = new ProposalMediaRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["mediaType"] = this.mediaType;
    data["mediaUrl"] = this.mediaUrl;
    data["originalFilename"] = this.originalFilename;
    data["priorityAsc"] = this.priorityAsc;
    return data;
  }
}

export interface IProposalMediaRequest {
  id?: number | undefined;
  mediaType?: MediaTypeEnum;
  mediaUrl?: string | undefined;
  originalFilename?: string | undefined;
  priorityAsc?: number;
}

export class ProposalMediaResponse implements IProposalMediaResponse {
  id?: number | undefined;
  mediaType!: MediaTypeEnum;
  mediaUrl?: string | undefined;
  originalFilename?: string | undefined;
  priorityAsc?: number;

  constructor(data?: IProposalMediaResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.mediaType = _data["mediaType"];
      this.mediaUrl = _data["mediaUrl"];
      this.originalFilename = _data["originalFilename"];
      this.priorityAsc = _data["priorityAsc"];
    }
  }

  static fromJS(data: any): ProposalMediaResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalMediaResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["mediaType"] = this.mediaType;
    data["mediaUrl"] = this.mediaUrl;
    data["originalFilename"] = this.originalFilename;
    data["priorityAsc"] = this.priorityAsc;
    return data;
  }
}

export interface IProposalMediaResponse {
  id?: number | undefined;
  mediaType: MediaTypeEnum;
  mediaUrl?: string | undefined;
  originalFilename?: string | undefined;
  priorityAsc?: number;
}

export class ProposalResponse implements IProposalResponse {
  id!: string;
  status!: ProposalStatusEnum;
  created!: Date;
  updated!: Date;
  createdById!: string;
  reviewerId?: string | undefined;
  updatedBy?: string | undefined;
  dealerNumber!: string;
  workOrderId?: string | undefined;
  businessProposalId?: string | undefined;
  proposalItems!: ProposalItemResponse[];
  proposalStatusHistories!: ProposalStatusHistoryResponse[];
  proposalVehicle!: ProposalVehicleResponse;
  proposalCustomer?: ProposalCustomerResponse;

  constructor(data?: IProposalResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.proposalItems = [];
      this.proposalStatusHistories = [];
      this.proposalVehicle = new ProposalVehicleResponse();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.status = _data["status"];
      this.created = _data["created"]
        ? new Date(_data["created"].toString())
        : <any>undefined;
      this.updated = _data["updated"]
        ? new Date(_data["updated"].toString())
        : <any>undefined;
      this.createdById = _data["createdById"];
      this.reviewerId = _data["reviewerId"];
      this.updatedBy = _data["updatedBy"];
      this.dealerNumber = _data["dealerNumber"];
      this.workOrderId = _data["workOrderId"];
      this.businessProposalId = _data["businessProposalId"];
      if (Array.isArray(_data["proposalItems"])) {
        this.proposalItems = [] as any;
        for (let item of _data["proposalItems"])
          this.proposalItems!.push(ProposalItemResponse.fromJS(item));
      }
      if (Array.isArray(_data["proposalStatusHistories"])) {
        this.proposalStatusHistories = [] as any;
        for (let item of _data["proposalStatusHistories"])
          this.proposalStatusHistories!.push(
            ProposalStatusHistoryResponse.fromJS(item)
          );
      }
      this.proposalVehicle = _data["proposalVehicle"]
        ? ProposalVehicleResponse.fromJS(_data["proposalVehicle"])
        : new ProposalVehicleResponse();
      this.proposalCustomer = _data["proposalCustomer"]
        ? ProposalCustomerResponse.fromJS(_data["proposalCustomer"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ProposalResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["status"] = this.status;
    data["created"] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data["updated"] = this.updated
      ? this.updated.toISOString()
      : <any>undefined;
    data["createdById"] = this.createdById;
    data["reviewerId"] = this.reviewerId;
    data["updatedBy"] = this.updatedBy;
    data["dealerNumber"] = this.dealerNumber;
    data["workOrderId"] = this.workOrderId;
    data["businessProposalId"] = this.businessProposalId;
    if (Array.isArray(this.proposalItems)) {
      data["proposalItems"] = [];
      for (let item of this.proposalItems)
        data["proposalItems"].push(item.toJSON());
    }
    if (Array.isArray(this.proposalStatusHistories)) {
      data["proposalStatusHistories"] = [];
      for (let item of this.proposalStatusHistories)
        data["proposalStatusHistories"].push(item.toJSON());
    }
    data["proposalVehicle"] = this.proposalVehicle
      ? this.proposalVehicle.toJSON()
      : <any>undefined;
    data["proposalCustomer"] = this.proposalCustomer
      ? this.proposalCustomer.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IProposalResponse {
  id: string;
  status: ProposalStatusEnum;
  created: Date;
  updated: Date;
  createdById: string;
  reviewerId?: string | undefined;
  updatedBy?: string | undefined;
  dealerNumber: string;
  workOrderId?: string | undefined;
  businessProposalId?: string | undefined;
  proposalItems: ProposalItemResponse[];
  proposalStatusHistories: ProposalStatusHistoryResponse[];
  proposalVehicle: ProposalVehicleResponse;
  proposalCustomer?: ProposalCustomerResponse;
}

export class ProposalResponseV2 implements IProposalResponseV2 {
  id?: string;
  status?: ProposalStatusEnum;
  created?: Date;
  updated?: Date;
  createdById?: string | undefined;
  reviewerId?: string | undefined;
  updatedBy?: string | undefined;
  dealerNumber?: string | undefined;
  workOrderId?: string | undefined;
  businessProposalId?: string | undefined;
  proposalVehicle?: ProposalVehicleResponse;
  proposalCustomer?: ProposalCustomerResponse;

  constructor(data?: IProposalResponseV2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.status = _data["status"];
      this.created = _data["created"]
        ? new Date(_data["created"].toString())
        : <any>undefined;
      this.updated = _data["updated"]
        ? new Date(_data["updated"].toString())
        : <any>undefined;
      this.createdById = _data["createdById"];
      this.reviewerId = _data["reviewerId"];
      this.updatedBy = _data["updatedBy"];
      this.dealerNumber = _data["dealerNumber"];
      this.workOrderId = _data["workOrderId"];
      this.businessProposalId = _data["businessProposalId"];
      this.proposalVehicle = _data["proposalVehicle"]
        ? ProposalVehicleResponse.fromJS(_data["proposalVehicle"])
        : <any>undefined;
      this.proposalCustomer = _data["proposalCustomer"]
        ? ProposalCustomerResponse.fromJS(_data["proposalCustomer"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ProposalResponseV2 {
    data = typeof data === "object" ? data : {};
    let result = new ProposalResponseV2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["status"] = this.status;
    data["created"] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data["updated"] = this.updated
      ? this.updated.toISOString()
      : <any>undefined;
    data["createdById"] = this.createdById;
    data["reviewerId"] = this.reviewerId;
    data["updatedBy"] = this.updatedBy;
    data["dealerNumber"] = this.dealerNumber;
    data["workOrderId"] = this.workOrderId;
    data["businessProposalId"] = this.businessProposalId;
    data["proposalVehicle"] = this.proposalVehicle
      ? this.proposalVehicle.toJSON()
      : <any>undefined;
    data["proposalCustomer"] = this.proposalCustomer
      ? this.proposalCustomer.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IProposalResponseV2 {
  id?: string;
  status?: ProposalStatusEnum;
  created?: Date;
  updated?: Date;
  createdById?: string | undefined;
  reviewerId?: string | undefined;
  updatedBy?: string | undefined;
  dealerNumber?: string | undefined;
  workOrderId?: string | undefined;
  businessProposalId?: string | undefined;
  proposalVehicle?: ProposalVehicleResponse;
  proposalCustomer?: ProposalCustomerResponse;
}

export enum ProposalStatusEnum {
  New = "New",
  UnderReview = "UnderReview",
  Reviewed = "Reviewed",
  Sent = "Sent",
  Opened = "Opened",
  CustomerAnswered = "CustomerAnswered",
  Closed = "Closed"
}

export class ProposalStatusHistoryResponse
  implements IProposalStatusHistoryResponse
{
  id!: number;
  timestamp!: Date;
  proposalId!: string;
  status!: ProposalStatusEnum;
  user?: string | undefined;

  constructor(data?: IProposalStatusHistoryResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.timestamp = _data["timestamp"]
        ? new Date(_data["timestamp"].toString())
        : <any>undefined;
      this.proposalId = _data["proposalId"];
      this.status = _data["status"];
      this.user = _data["user"];
    }
  }

  static fromJS(data: any): ProposalStatusHistoryResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalStatusHistoryResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["timestamp"] = this.timestamp
      ? this.timestamp.toISOString()
      : <any>undefined;
    data["proposalId"] = this.proposalId;
    data["status"] = this.status;
    data["user"] = this.user;
    return data;
  }
}

export interface IProposalStatusHistoryResponse {
  id: number;
  timestamp: Date;
  proposalId: string;
  status: ProposalStatusEnum;
  user?: string | undefined;
}

export class ProposalVehicleResponse implements IProposalVehicleResponse {
  id!: number;
  chassi!: string;
  registrationNumber!: string;
  modelText!: string;
  brand!: BrandCodeEnum;

  constructor(data?: IProposalVehicleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.chassi = _data["chassi"];
      this.registrationNumber = _data["registrationNumber"];
      this.modelText = _data["modelText"];
      this.brand = _data["brand"];
    }
  }

  static fromJS(data: any): ProposalVehicleResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProposalVehicleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["chassi"] = this.chassi;
    data["registrationNumber"] = this.registrationNumber;
    data["modelText"] = this.modelText;
    data["brand"] = this.brand;
    return data;
  }
}

export interface IProposalVehicleResponse {
  id: number;
  chassi: string;
  registrationNumber: string;
  modelText: string;
  brand: BrandCodeEnum;
}

export class SearchProposalDataResponse implements ISearchProposalDataResponse {
  id?: string;
  status?: ProposalStatusEnum;
  updated?: Date;
  updatedBy?: string | undefined;
  proposalItems?: SearchProposalItemResponse[] | undefined;
  proposalVehicle?: SearchProposalVehicleResponse;

  constructor(data?: ISearchProposalDataResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.status = _data["status"];
      this.updated = _data["updated"]
        ? new Date(_data["updated"].toString())
        : <any>undefined;
      this.updatedBy = _data["updatedBy"];
      if (Array.isArray(_data["proposalItems"])) {
        this.proposalItems = [] as any;
        for (let item of _data["proposalItems"])
          this.proposalItems!.push(SearchProposalItemResponse.fromJS(item));
      }
      this.proposalVehicle = _data["proposalVehicle"]
        ? SearchProposalVehicleResponse.fromJS(_data["proposalVehicle"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): SearchProposalDataResponse {
    data = typeof data === "object" ? data : {};
    let result = new SearchProposalDataResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["status"] = this.status;
    data["updated"] = this.updated
      ? this.updated.toISOString()
      : <any>undefined;
    data["updatedBy"] = this.updatedBy;
    if (Array.isArray(this.proposalItems)) {
      data["proposalItems"] = [];
      for (let item of this.proposalItems)
        data["proposalItems"].push(item.toJSON());
    }
    data["proposalVehicle"] = this.proposalVehicle
      ? this.proposalVehicle.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface ISearchProposalDataResponse {
  id?: string;
  status?: ProposalStatusEnum;
  updated?: Date;
  updatedBy?: string | undefined;
  proposalItems?: SearchProposalItemResponse[] | undefined;
  proposalVehicle?: SearchProposalVehicleResponse;
}

export class SearchProposalItemResponse implements ISearchProposalItemResponse {
  id?: number;
  customerAccepted?: boolean | undefined;

  constructor(data?: ISearchProposalItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.customerAccepted = _data["customerAccepted"];
    }
  }

  static fromJS(data: any): SearchProposalItemResponse {
    data = typeof data === "object" ? data : {};
    let result = new SearchProposalItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["customerAccepted"] = this.customerAccepted;
    return data;
  }
}

export interface ISearchProposalItemResponse {
  id?: number;
  customerAccepted?: boolean | undefined;
}

export class SearchProposalResponse implements ISearchProposalResponse {
  proposals?: SearchProposalDataResponse[] | undefined;
  totalCount!: number;

  constructor(data?: ISearchProposalResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["proposals"])) {
        this.proposals = [] as any;
        for (let item of _data["proposals"])
          this.proposals!.push(SearchProposalDataResponse.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): SearchProposalResponse {
    data = typeof data === "object" ? data : {};
    let result = new SearchProposalResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.proposals)) {
      data["proposals"] = [];
      for (let item of this.proposals) data["proposals"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }
}

export interface ISearchProposalResponse {
  proposals?: SearchProposalDataResponse[] | undefined;
  totalCount: number;
}

export class SearchProposalVehicleResponse
  implements ISearchProposalVehicleResponse
{
  id?: number;
  registrationNumber?: string | undefined;
  modelText?: string | undefined;
  brand?: BrandCodeEnum;

  constructor(data?: ISearchProposalVehicleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.registrationNumber = _data["registrationNumber"];
      this.modelText = _data["modelText"];
      this.brand = _data["brand"];
    }
  }

  static fromJS(data: any): SearchProposalVehicleResponse {
    data = typeof data === "object" ? data : {};
    let result = new SearchProposalVehicleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["registrationNumber"] = this.registrationNumber;
    data["modelText"] = this.modelText;
    data["brand"] = this.brand;
    return data;
  }
}

export interface ISearchProposalVehicleResponse {
  id?: number;
  registrationNumber?: string | undefined;
  modelText?: string | undefined;
  brand?: BrandCodeEnum;
}

export class SendProposalRequest implements ISendProposalRequest {
  proposalId!: string;
  reviewerId!: string;
  updatedById?: string | undefined;
  mechanicName?: string | undefined;
  advisorName?: string | undefined;
  mechanicUserId?: string | undefined;
  advisorUserId?: string | undefined;
  showMechanicName?: boolean | undefined;
  showAdvisorName?: boolean | undefined;

  constructor(data?: ISendProposalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.proposalId = _data["proposalId"];
      this.reviewerId = _data["reviewerId"];
      this.updatedById = _data["updatedById"];
      this.mechanicName = _data["mechanicName"];
      this.advisorName = _data["advisorName"];
      this.mechanicUserId = _data["mechanicUserId"];
      this.advisorUserId = _data["advisorUserId"];
      this.showMechanicName = _data["showMechanicName"];
      this.showAdvisorName = _data["showAdvisorName"];
    }
  }

  static fromJS(data: any): SendProposalRequest {
    data = typeof data === "object" ? data : {};
    let result = new SendProposalRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["proposalId"] = this.proposalId;
    data["reviewerId"] = this.reviewerId;
    data["updatedById"] = this.updatedById;
    data["mechanicName"] = this.mechanicName;
    data["advisorName"] = this.advisorName;
    data["mechanicUserId"] = this.mechanicUserId;
    data["advisorUserId"] = this.advisorUserId;
    data["showMechanicName"] = this.showMechanicName;
    data["showAdvisorName"] = this.showAdvisorName;
    return data;
  }
}

export interface ISendProposalRequest {
  proposalId: string;
  reviewerId: string;
  updatedById?: string | undefined;
  mechanicName?: string | undefined;
  advisorName?: string | undefined;
  mechanicUserId?: string | undefined;
  advisorUserId?: string | undefined;
  showMechanicName?: boolean | undefined;
  showAdvisorName?: boolean | undefined;
}

export class UpdateDamageInspectionItemMediaRequest
  implements IUpdateDamageInspectionItemMediaRequest
{
  id?: number;
  mediaName!: string | undefined;

  constructor(data?: IUpdateDamageInspectionItemMediaRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.mediaName = _data["mediaName"];
    }
  }

  static fromJS(data: any): UpdateDamageInspectionItemMediaRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateDamageInspectionItemMediaRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["mediaName"] = this.mediaName;
    return data;
  }
}

export interface IUpdateDamageInspectionItemMediaRequest {
  id?: number;
  mediaName: string | undefined;
}

export class UpdateDamageInspectionItemRequest
  implements IUpdateDamageInspectionItemRequest
{
  id?: number;
  title?: string | undefined;

  constructor(data?: IUpdateDamageInspectionItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
    }
  }

  static fromJS(data: any): UpdateDamageInspectionItemRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateDamageInspectionItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    return data;
  }
}

export interface IUpdateDamageInspectionItemRequest {
  id?: number;
  title?: string | undefined;
}

export class UpdateDamageInspectionRequest
  implements IUpdateDamageInspectionRequest
{
  isReviewed?: boolean | undefined;
  reviewedBy?: string | undefined;

  constructor(data?: IUpdateDamageInspectionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isReviewed = _data["isReviewed"];
      this.reviewedBy = _data["reviewedBy"];
    }
  }

  static fromJS(data: any): UpdateDamageInspectionRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateDamageInspectionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["isReviewed"] = this.isReviewed;
    data["reviewedBy"] = this.reviewedBy;
    return data;
  }
}

export interface IUpdateDamageInspectionRequest {
  isReviewed?: boolean | undefined;
  reviewedBy?: string | undefined;
}

export class UpdateMaterialInspectionItemMediaRequest
  implements IUpdateMaterialInspectionItemMediaRequest
{
  id?: number;
  mediaName!: string | undefined;

  constructor(data?: IUpdateMaterialInspectionItemMediaRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.mediaName = _data["mediaName"];
    }
  }

  static fromJS(data: any): UpdateMaterialInspectionItemMediaRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateMaterialInspectionItemMediaRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["mediaName"] = this.mediaName;
    return data;
  }
}

export interface IUpdateMaterialInspectionItemMediaRequest {
  id?: number;
  mediaName: string | undefined;
}

export class UpdateMaterialInspectionItemRequest
  implements IUpdateMaterialInspectionItemRequest
{
  id?: number;
  title?: string | undefined;
  isReviewed?: boolean;
  reviewedBy?: string | undefined;

  constructor(data?: IUpdateMaterialInspectionItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
      this.isReviewed = _data["isReviewed"];
      this.reviewedBy = _data["reviewedBy"];
    }
  }

  static fromJS(data: any): UpdateMaterialInspectionItemRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateMaterialInspectionItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    data["isReviewed"] = this.isReviewed;
    data["reviewedBy"] = this.reviewedBy;
    return data;
  }
}

export interface IUpdateMaterialInspectionItemRequest {
  id?: number;
  title?: string | undefined;
  isReviewed?: boolean;
  reviewedBy?: string | undefined;
}

export class UpdateMaterialInspectionRequest
  implements IUpdateMaterialInspectionRequest
{
  isReviewed?: boolean | undefined;
  hasConfirmedMediaForAllSteps?: boolean | undefined;
  reviewedBy?: string | undefined;

  constructor(data?: IUpdateMaterialInspectionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isReviewed = _data["isReviewed"];
      this.hasConfirmedMediaForAllSteps = _data["hasConfirmedMediaForAllSteps"];
      this.reviewedBy = _data["reviewedBy"];
    }
  }

  static fromJS(data: any): UpdateMaterialInspectionRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateMaterialInspectionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["isReviewed"] = this.isReviewed;
    data["hasConfirmedMediaForAllSteps"] = this.hasConfirmedMediaForAllSteps;
    data["reviewedBy"] = this.reviewedBy;
    return data;
  }
}

export interface IUpdateMaterialInspectionRequest {
  isReviewed?: boolean | undefined;
  hasConfirmedMediaForAllSteps?: boolean | undefined;
  reviewedBy?: string | undefined;
}

export class UpdateProposalItemRequest implements IUpdateProposalItemRequest {
  updatedById!: string | undefined;
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price?: number;
  requiredTime?: number;
  packages?: ProposalMediaPackageRequest[] | undefined;
  medias?: ProposalMediaRequest[] | undefined;
  customerAccepted?: boolean | undefined;
  status?: ProposalItemStatus;

  constructor(data?: IUpdateProposalItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.updatedById = _data["updatedById"];
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.priorityId = _data["priorityId"];
      this.price = _data["price"];
      this.requiredTime = _data["requiredTime"];
      if (Array.isArray(_data["packages"])) {
        this.packages = [] as any;
        for (let item of _data["packages"])
          this.packages!.push(ProposalMediaPackageRequest.fromJS(item));
      }
      if (Array.isArray(_data["medias"])) {
        this.medias = [] as any;
        for (let item of _data["medias"])
          this.medias!.push(ProposalMediaRequest.fromJS(item));
      }
      this.customerAccepted = _data["customerAccepted"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): UpdateProposalItemRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateProposalItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["updatedById"] = this.updatedById;
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    data["priorityId"] = this.priorityId;
    data["price"] = this.price;
    data["requiredTime"] = this.requiredTime;
    if (Array.isArray(this.packages)) {
      data["packages"] = [];
      for (let item of this.packages) data["packages"].push(item.toJSON());
    }
    if (Array.isArray(this.medias)) {
      data["medias"] = [];
      for (let item of this.medias) data["medias"].push(item.toJSON());
    }
    data["customerAccepted"] = this.customerAccepted;
    data["status"] = this.status;
    return data;
  }
}

export interface IUpdateProposalItemRequest {
  updatedById: string | undefined;
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
  priorityId?: number | undefined;
  price?: number;
  requiredTime?: number;
  packages?: ProposalMediaPackageRequest[] | undefined;
  medias?: ProposalMediaRequest[] | undefined;
  customerAccepted?: boolean | undefined;
  status?: ProposalItemStatus;
}

export class UpdateProposalRequest implements IUpdateProposalRequest {
  id!: string;
  status!: ProposalStatusEnum;
  reviewerId?: string | undefined;
  workOrderId?: string | undefined;
  updatedById?: string | undefined;
  businessProposalId?: string | undefined;
  proposalItems?: ProposalItemRequest[] | undefined;
  proposalCustomer!: ProposalCustomerRequest;

  constructor(data?: IUpdateProposalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.proposalCustomer = new ProposalCustomerRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.status = _data["status"];
      this.reviewerId = _data["reviewerId"];
      this.workOrderId = _data["workOrderId"];
      this.updatedById = _data["updatedById"];
      this.businessProposalId = _data["businessProposalId"];
      if (Array.isArray(_data["proposalItems"])) {
        this.proposalItems = [] as any;
        for (let item of _data["proposalItems"])
          this.proposalItems!.push(ProposalItemRequest.fromJS(item));
      }
      this.proposalCustomer = _data["proposalCustomer"]
        ? ProposalCustomerRequest.fromJS(_data["proposalCustomer"])
        : new ProposalCustomerRequest();
    }
  }

  static fromJS(data: any): UpdateProposalRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateProposalRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["status"] = this.status;
    data["reviewerId"] = this.reviewerId;
    data["workOrderId"] = this.workOrderId;
    data["updatedById"] = this.updatedById;
    data["businessProposalId"] = this.businessProposalId;
    if (Array.isArray(this.proposalItems)) {
      data["proposalItems"] = [];
      for (let item of this.proposalItems)
        data["proposalItems"].push(item.toJSON());
    }
    data["proposalCustomer"] = this.proposalCustomer
      ? this.proposalCustomer.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IUpdateProposalRequest {
  id: string;
  status: ProposalStatusEnum;
  reviewerId?: string | undefined;
  workOrderId?: string | undefined;
  updatedById?: string | undefined;
  businessProposalId?: string | undefined;
  proposalItems?: ProposalItemRequest[] | undefined;
  proposalCustomer: ProposalCustomerRequest;
}

export class UpdateProposalRequestV2 implements IUpdateProposalRequestV2 {
  id!: string;
  status!: ProposalStatusEnum;
  reviewerId?: string | undefined;
  workOrderId?: string | undefined;
  updatedById?: string | undefined;
  businessProposalId?: string | undefined;
  proposalCustomer!: ProposalCustomerRequest;

  constructor(data?: IUpdateProposalRequestV2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.proposalCustomer = new ProposalCustomerRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.status = _data["status"];
      this.reviewerId = _data["reviewerId"];
      this.workOrderId = _data["workOrderId"];
      this.updatedById = _data["updatedById"];
      this.businessProposalId = _data["businessProposalId"];
      this.proposalCustomer = _data["proposalCustomer"]
        ? ProposalCustomerRequest.fromJS(_data["proposalCustomer"])
        : new ProposalCustomerRequest();
    }
  }

  static fromJS(data: any): UpdateProposalRequestV2 {
    data = typeof data === "object" ? data : {};
    let result = new UpdateProposalRequestV2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["status"] = this.status;
    data["reviewerId"] = this.reviewerId;
    data["workOrderId"] = this.workOrderId;
    data["updatedById"] = this.updatedById;
    data["businessProposalId"] = this.businessProposalId;
    data["proposalCustomer"] = this.proposalCustomer
      ? this.proposalCustomer.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IUpdateProposalRequestV2 {
  id: string;
  status: ProposalStatusEnum;
  reviewerId?: string | undefined;
  workOrderId?: string | undefined;
  updatedById?: string | undefined;
  businessProposalId?: string | undefined;
  proposalCustomer: ProposalCustomerRequest;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new SwaggerException(message, status, response, headers, null);
}
